import { gate } from 'hub-http/gates';
export const gates = {
  CONVERSATIONAL_ENRICHMENT_BETA: gate('ConversationalEnrichment:EmailParser:Beta'),
  CONVERSATIONAL_ENRICHMENT_EMPLOYMENT_CHANGE: gate('ConversationalEnrichment:Model:EmploymentChange'),
  ENRICHMENT_ASSOCIATIONS_LISTS: gate('DataEnrichment:AssociationsLists'),
  ENRICHMENT_AUTO_LAST_ENGAGEMENT_COMPANIES: gate('DataEnrichment:LastEngagementCompanies'),
  ENRICHMENT_AUTO_PAUSE: gate('DataEnrichment:AutoPause'),
  ENRICHMENT_IMPORTS_TOOLS: gate('DataEnrichment:AutoImportsTools'),
  ENRICHMENT_SMART_PROPERTIES: gate('DataEnrichment:SmartProperties')
};